import React from 'react'
import { Flex, Skeleton, csx } from '@vtex/admin-ui'

export const SalesAssociatesCardsSkeleton = () => (
  <>
    {[...Array(6).keys()].map((_, index) => (
      <Flex
        key={index}
        className={csx({
          paddingY: 5,
          paddingX: 5,
          border: '$neutral',
          borderRadius: 'default',
          justifyContent: 'space-between',
          alignItems: 'center',
        })}
      >
        <Skeleton className={csx({ width: '60%', height: '1.125rem' })} />
        <Skeleton
          className={csx({ width: '2.5rem', height: '2.5rem' })}
          shape="circle"
        />
      </Flex>
    ))}
  </>
)
